var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",on:{"click":_vm.jumpPage}},[_vm._v("user")])
}
var staticRenderFns = []

export { render, staticRenderFns }